import HTTP from '../../../../api/AxiosConfig';

export const getProducts = (request) =>
    HTTP.post('/products', request);

export const createProduct = (request) =>
    HTTP.post('/products/create', request);

export const updateProduct = (product) =>
    HTTP.put('/products', product);

export const deleteProduct = (id) =>
    HTTP.delete('/products?id=' + id);

export const getAllProductsList = () =>
    HTTP.get('/products/all');

export const getAllProductsGroups = (lang) =>
    HTTP.get(`/product-groups?lang=${lang}`);